import { defineMessages } from "react-intl";

export default defineMessages({
  sendARequestAlertText: {
    id: 'sendARequestAlertText',
    defaultMessage: 'If you would like to request a personalized assessment to evaluate your tools needs or if you have any questions about BETMS please do not hesitate to contact us.'
  }
});